/**
 * Hệ thống tài khoản
 */
export default {

  //Phiếu chi C37-HD
  C37HD: 'C37_HD',
  //Phiếu chi C41BB
  C41BB: 'C41BB',

  //Phiếu thu C40BB
  C40BB: 'C40BB',

  C202a_ND11: 'C202a_ND11',
  
  C202b_ND11: 'C202b_ND11',

  BC_56_01_ND11_2020: 'BC_56_01_ND11_2020',
  
  // Nhưng báo cáo nào dùng common id làm key chung thì thêm cái này
  Use_Common: '_Use_Common'
};
